import { SearchResultAddButtonComponent } from './search-results-add-button.component';
import { SearchResultsComponent } from './search-results.component';

export const SEARCH_RESULTS_DIRECTIVES = [
  SearchResultsComponent,
  SearchResultAddButtonComponent
] as const;
